export default __webpack_public_path__ + "static/media/gsap.f1e3e34a.png";